import {
  getISODay,
  nextMonday,
  nextTuesday,
  nextWednesday,
  nextThursday,
  nextFriday,
  nextSaturday,
  nextSunday,
} from 'date-fns';

export const getNextDay = (day: number) => {
  if (day === getISODay(new Date())) {
    return new Date();
  }
  switch (day) {
    case 1:
      return nextMonday(new Date());
    case 2:
      return nextTuesday(new Date());
    case 3:
      return nextWednesday(new Date());
    case 4:
      return nextThursday(new Date());
    case 5:
      return nextFriday(new Date());
    case 6:
      return nextSaturday(new Date());
    case 7:
      return nextSunday(new Date());
    default:
      return new Date();
  }
};
